function bitmapFontPadding(referenceSize: number): number {
  const size = Math.max(0, Math.round(referenceSize))
  return Math.round(size / 10) + Math.ceil(size / 20)
}

/**
 * 3.0 画字字号。剧情包 padding 按名义字号；存读档按最宽字形。
 */
export function resolveBitmapFontRasterSize(
  nominalFontSize: number,
  paddingReferenceSize = nominalFontSize,
): number {
  const nominal = Math.max(1, Math.round(nominalFontSize))
  return Math.max(2, nominal - bitmapFontPadding(paddingReferenceSize))
}
